// Persian (Farsi)
export const fa = {
    weeklyRewards: 'جوایز هفتگی در',
    days: 'روز',
    hours: 'ساعت',
    minutes: 'دقیقه',
    seconds: 'ثانیه',
    authenticating: 'در حال احراز هویت',
    verifyWallet: 'لطفاً صبر کنید تا کیف پول شما را تأیید کنیم',
    authRequired: 'احراز هویت لازم است',
    authFailed: 'احراز هویت ناموفق بود. لطفاً دوباره تلاش کنید.',
    points: 'امتیاز',
    rank: 'رتبه',
    of: 'از',
    players: 'بازیکنان',
    weeklyTopPlayers: 'بازیکنان برتر هفته',
    thisWeekLeaderboard: 'جدول امتیازات این هفته',
    rankingsReset: 'رتبه‌بندی هر یکشنبه در نیمه شب UTC بازنشانی می‌شود',
    yourPoints: 'امتیازات شما',
    dailyRewardAvailable: 'جایزه روزانه در دسترس است!',
    nextClaimAvailable: 'دریافت بعدی در دسترس در:',
    claimDailyReward: 'دریافت جایزه روزانه',
    claiming: 'در حال دریافت...',
    multiplier: 'ضریب',
    bonusPointsMultiplier: 'ضریب امتیازات بونوس',
    outOf: 'از',
    loading: 'در حال بارگذاری...',
    errorLoading: 'خطا در بارگذاری',
    noEntries: 'هنوز موردی وجود ندارد',
    leaderboard: 'جدول امتیازات',
    tasks: 'وظایف',
    rules: 'قوانین',
    profile: 'پروفایل',
    comingSoon: 'به زودی...',
    completedTasks: 'وظایف تکمیل شده',
    dailyRewardsClaimed: 'جوایز روزانه دریافت شده',
    times: 'بار',
    recentActivity: 'فعالیت اخیر',
    noRewardsClaimed: 'هنوز جایزه‌ای دریافت نشده است',
    dailyReward: 'جایزه روزانه',
    howItWorks: 'نحوه کار',
    welcomeMessage:
        'به Coinomi Rewards خوش آمدید! با تکمیل وظایف مختلف امتیاز کسب کنید و در جدول امتیازات بالا بروید.',
    dailyRewardsTitle: 'جوایز روزانه',
    dailyRewardsRules: [
        'جایزه روزانه خود را هر 24 ساعت دریافت کنید',
        'هر دریافت 100 امتیاز به شما می‌دهد',
        'امتیازات بر اساس ضریب شما ضرب می‌شوند',
    ],
    multiplierBonusesTitle: 'بونوس‌های ضریب',
    multiplierBonusesRules: [
        'با ضریب 1x شروع کنید',
        'برای بونوس +10% تلگرام را متصل کنید',
        'برای بونوس +10% ایمیل را تأیید کنید',
        'بونوس‌ها برای حداکثر پاداش جمع می‌شوند',
    ],
    leaderboardTitle: 'جدول امتیازات',
    leaderboardRules: [
        'با سایر بازیکنان رقابت کنید',
        'رتبه‌بندی در زمان واقعی به‌روز می‌شود',
        'بازیکنان برتر جوایز ویژه دریافت می‌کنند',
    ],
    boostEarningsTitle: 'درآمد خود را افزایش دهید',
    boostEarningsRules: [
        'چالش‌ها را برای کسب بونوس تکمیل کنید',
        'به جامعه تلگرام ما بپیوندید',
        'برای حداکثر پاداش فعال بمانید',
    ],
    challenges: 'چالش‌ها',
    telegramChallenge: 'چالش تلگرام',
    emailChallenge: 'چالش ایمیل',
    connectTelegram: 'اتصال به تلگرام',
    shareEmail: 'اشتراک‌گذاری ایمیل',
    telegramSuccess: '🎉 تبریک! شما اکنون یک بونوس دائمی 10% برای تمام جوایز دریافت می‌کنید!',
    telegramPrompt:
        'حساب تلگرام خود را متصل کنید تا یک بونوس دائمی 10% برای تمام جوایز دریافت کنید!',
    emailSuccess: '🎉 تبریک! شما اکنون یک بونوس دائمی 10% برای تمام جوایز دریافت می‌کنید!',
    emailPrompt:
        'ایمیل خود را به اشتراک بگذارید تا یک بونوس دائمی 10% برای تمام جوایز دریافت کنید!',
    connectEmail: 'اتصال ایمیل',
    cancel: 'لغو',
    emailPrivacy: 'ما فقط از ایمیل شما برای به‌روزرسانی‌های مهم و اعلان‌های جوایز استفاده می‌کنیم.',
    connectYourEmail: 'ایمیل خود را متصل کنید',
    emailBonus: '🎉 با اتصال ایمیل خود یک بونوس دائمی 10% برای تمام جوایز دریافت کنید!',
    enterValidEmail: 'لطفاً یک آدرس ایمیل معتبر وارد کنید',
    emailAddress: 'آدرس ایمیل',
    errorSavingEmail: 'خطا در ذخیره ایمیل. لطفاً دوباره تلاش کنید.',
    claimButton: 'دریافت',
    earnedReward: 'جایزه کسب شده',
    rewardValue: '{{amount}} امتیاز',
    claimingReward: 'در حال دریافت...',
    claimSuccess: 'با موفقیت {{amount}} امتیاز دریافت شد!',
    claimError: 'دریافت جایزه ناموفق بود. لطفاً دوباره تلاش کنید.',
    privacyDisclaimer:
        'Coinomi داده‌های شخصی جمع‌آوری نمی‌کند؛ یک سیستم شخص ثالث به طور امن امتیازات و پیوندهای اجتماعی را مدیریت می‌کند.',
    streakBonus: 'بونوس توالی',
    streakDays: '{{days}}/5 روز',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% اضافی',
    streakDescription: 'برای حداکثر بونوس 5 روز متوالی دریافت کنید',
    streakToday: 'امروز',
    streakMissed: 'از دست رفته',
    streakComplete: 'کامل',
    streakActive: 'توالی فعال',
    streakLost: 'توالی از دست رفته',
    streakNext: 'بعدی',
    home: 'خانه',
    currentStreak: 'توالی فعلی',
    totalClaims: 'کل دریافت‌ها',
    userStats: 'آمار شما',
    referrals: 'معرفی‌ها',
    referralProgram: 'برنامه معرفی',
    howReferralWorks: 'نحوه کار معرفی:',
    referralSteps: [
        'لینک معرفی خود را با دوستان به اشتراک بگذارید',
        'وقتی آنها با استفاده از لینک شما می‌پیوندند، معرفی شده شما می‌شوند',
        'برای هر معرفی فعال امتیاز بونوس کسب کنید',
        'معرفی‌ها و درآمد خود را اینجا پیگیری کنید',
    ],
    referralRewards: 'امتیازات معرفی اعطا می‌شود:',
    referralBonuses: [
        '100 امتیاز برای هر معرفی',
        '10% از تمام امتیازاتی که معرفی شده‌ها کسب می‌کنند',
    ],
    yourReferralLink: 'لینک معرفی شما',
    copyToClipboard: 'کپی در کلیپ‌بورد',
    linkCopied: 'لینک در کلیپ‌بورد کپی شد!',
    totalReferrals: 'کل معرفی‌ها',
    yourReferralCode: 'کد معرفی شما',
    referralCodeCopied: 'کد معرفی کپی شد!',
    editReferralCode: 'ویرایش کد معرفی',
    editReferralCodeInstructions:
        'یک کد معرفی جدید انتخاب کنید. باید حداقل 5 کاراکتر باشد و می‌تواند شامل حروف و اعداد باشد.',
    newReferralCode: 'کد معرفی جدید',
    referralCodeRequirements: 'حداقل 5 کاراکتر، فقط حروف و اعداد',
    updating: 'در حال به‌روزرسانی...',
    update: 'به‌روزرسانی',
    referralCodeTaken: 'این کد معرفی قبلاً گرفته شده است',
    haveReferralCode: 'کد معرفی دارید؟',
    enterReferralCodePrompt:
        'اگر کسی شما را معرفی کرده است، کد آنها را اینجا وارد کنید تا حساب‌ها متصل شوند.',
    enterReferralCode: 'کد معرفی را وارد کنید',
    enterReferralCodeInstructions: 'کد معرفی که با شما به اشتراک گذاشته شده را وارد کنید.',
    referralCode: 'کد معرفی',
    referralCodeFormat: 'فقط حروف و اعداد',
    submitting: 'در حال ارسال...',
    submit: 'ارسال',
    enterCode: 'کد را وارد کنید',
    pleaseAddtoken: 'لطفاً یک پارامتر token به URL اضافه کنید',
    authenticationError: 'خطایی در حین احراز هویت رخ داد',
    noUserFound: 'کاربری یافت نشد',
    userNotFoundMessage: 'داده‌های کاربر یافت نشد',
    backToHome: 'بازگشت به خانه',
    retry: 'تلاش مجدد',
    baseMultiplier: 'ضریب پایه',
    telegramBonus: 'بونوس تلگرام',
    referralChallenge: 'چالش معرفی',
    referralChallengePrompt:
        'دوستان را دعوت کنید و امتیاز بونوس کسب کنید! برای هر معرفی 100 امتیاز به علاوه 10% از درآمد آنها دریافت کنید.',
    startReferring: 'شروع معرفی',
    referralSuccess:
        '🎉 تبریک! شما با موفقیت کاربران را معرفی کرده‌اید و در حال کسب امتیازات بونوس هستید!',
    unranked: 'بدون رتبه',
    noPlayersYet: 'اولین نفری باشید که می‌پیوندد!',
    shareVia: 'اشتراک‌گذاری از طریق',
    shareOn: 'اشتراک‌گذاری در {{network}}',
    shareInviteText:
        '🚀 من با @CoinomiWallet ارز دیجیتال رایگان دریافت می‌کنم!\n\nCoinomi را از coinomi.com/downloads دانلود کنید و کد معرف من {{referralCode}} را وارد کنید تا هنگام پیوستن به #Coinomi Rewards در برنامه، پاداش بگیرید.',
    yourStatsThisWeek: 'آمار شما در این هفته',
    pointsMultiplier: 'ضریب امتیازات',
    yourRank: 'رتبه شما',
    rewards: 'پاداش‌ها',
    daily: 'روزانه',
    weekly: 'هفتگی',
    claimRewards: 'دریافت پاداش‌ها',
    copy: 'کپی',
    pleaseAddUserId: 'Please add a userId parameter to the URL',
    emailChallengePrompt: 'Share your email to get a permanent 10% bonus on all rewards!',
    emailChallengeSuccess:
        '🎉 Connected! You are now receiving a permanent 10% bonus on all rewards!',
    followKoalaWalletChallenge: 'Follow @coinomiWallet on Twitter to support us!',
    twitterAuthSuccessTitle: 'Twitter Connected Successfully!',
    twitterAuthSuccessMessage:
        'You have successfully connected your Twitter account. You can now continue using the app.',
    continueToApp: 'Continue to App',
    twitter_like: 'Liked a tweet',
    twitter_retweet: 'Retweeted a tweet',
    disconnect: 'قطع ارتباط',
    followCoinomiWallet: 'در توییتر @coinomiWallet را دنبال کنید تا از ما حمایت کنید!',
    connectedBonus: '🎉 متصل شد! اکنون شما ۱۰٪ پاداش دائمی برای همه جوایز دریافت می‌کنید!',
};
